import { z } from 'zod'
import { oc } from '@orpc/contract'

/**
 * Republish the Zocdoc days a set of deleted `Slot`s sat on.
 *
 * **Why the Schedule page has to say so.** The `Slot` Subscription is how the sync hears about a
 * calendar change, and it never hears about a delete — Medplum delivers one with an empty body.
 * "Set availability" deletes every future free slot and recreates the new pattern, so a day the new
 * pattern leaves empty (a dropped weekday, an earlier end date) gets deletes only, and Zocdoc keeps
 * advertising times beHuman no longer has. This is the page naming those days.
 *
 * Instants, not dates: which local day a slot falls on is the provider zone's business, and only
 * the reconcile runner resolves the zone.
 *
 * Fire-and-forget from the caller's side: the outcome is a queued run, never a published day.
 */
export const ZOCDOC_REPUBLISH_SKIP_REASONS = ['not-linked', 'sync-off'] as const

/** The page deletes with `_count=10000`, so that is the most one call can name. */
const MAX_INSTANTS = 10_000

export const zocdocRepublishAvailability = oc
  .route({ method: 'POST', path: '/v2/zocdoc/availability/republish' })
  .input(
    z.object({
      scheduleId: z.string().min(1),
      instants: z
        .array(z.string().datetime({ offset: true }))
        .min(1)
        .max(MAX_INSTANTS),
    }),
  )
  .output(
    z.object({
      enqueued: z.boolean(),
      /**
       * Why nothing was queued. `not-linked`: the schedule's practitioner is not on Zocdoc, which
       * is the ordinary case. `sync-off`: the reconcile task is disabled.
       */
      skipped: z.enum(ZOCDOC_REPUBLISH_SKIP_REASONS).optional(),
    }),
  )
